/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export var EventInfo;
(function (EventInfo) {
    var eventType;
    (function (eventType) {
        eventType["PRODUCT_CREATED"] = "productCreated";
        eventType["PRODUCT_UPDATED"] = "productUpdated";
        eventType["PRODUCT_DELETED"] = "productDeleted";
        eventType["PRODUCT_EXPIRED"] = "productExpired";
        eventType["PRICE_CREATED"] = "priceCreated";
        eventType["PRICE_UPDATED"] = "priceUpdated";
        eventType["PRICE_DELETED"] = "priceDeleted";
        eventType["NSO_UPDATED"] = "nsoUpdated";
        eventType["KNOLL_ENGINEERING_PUBLISH"] = "knollEngineeringPublish";
        eventType["CREATE_PRODUCT_SPECIAL"] = "createProductSpecial";
        eventType["DELETE_FROM_PUB_LAYER"] = "deleteFromPubLayer";
        eventType["RESPONSE_REQUESTED"] = "responseRequested";
    })(eventType = EventInfo.eventType || (EventInfo.eventType = {}));
})(EventInfo || (EventInfo = {}));
